// @flow
import React from 'react';
import {connect} from 'react-redux';
import {MesoAdsContextWithSearchParams} from '@homeaway/react-meso-ads';

import type {SearchParamsType} from '../../reducers/searchParams';

type Props = {
    pathname: string,
    params: SearchParamsType,
    prevParams: SearchParamsType
};

function mapStateToProps(state) {
    const {searchParams} = state;

    return {
        pathname: searchParams.pathname,
        params: searchParams.params,
        prevParams: searchParams.prevParams
    };
}

function MesoAdsContextContainer(props: Props) {
    const {pathname, params, prevParams} = props;
    return (
        <MesoAdsContextWithSearchParams
            searchParams={{pathname, params, prevParams}}
            {...props}
        />
    );
}

export default connect(mapStateToProps)(MesoAdsContextContainer);
